import React from 'react';
import { useStore } from '../store/useStore';
import { t } from '../utils/i18n';

export function GlobalStatus() {
  const { loading, error, setError } = useStore();

  if (!loading && !error) return null;

  return (
    <>
      {loading && (
        <div className="fixed-overlay loading-overlay">
          <div className="spinner-container">
            <div className="spinner"></div>
            <div className="loading-text">{t('ui.loading') || 'Loading...'}</div>
          </div>
        </div>
      )}
      
      {error && (
        <div className="fixed-overlay error-overlay">
          <div className="card error-card">
            <div className="card-header" style={{ marginBottom: '12px' }}>
              <div className="flex items-center gap-sm">
                <span style={{ fontSize: '20px' }}>⚠️</span>
                <h3 className="card-title" style={{ color: 'var(--accent-danger)' }}>{t('ui.error') || 'Error'}</h3>
              </div>
            </div>
            <p className="error-message">{error}</p>
            <div className="flex gap-sm">
               <button className="btn btn-secondary flex-1" onClick={() => window.location.reload()}>
                 {t('ui.reload') || 'Reload'}
               </button>
               <button className="btn btn-danger flex-1" onClick={() => setError(null)}>
                 {t('ui.dismiss') || 'Close'}
               </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
